import React, { Component } from 'react';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink } from '@react-pdf/renderer';
import { Container, Avatar, Paper, Grid, Breadcrumbs, Link, Typography, TextField, Table, TableContainer, Button, TableHead, TableRow, TableBody, TableCell,IconButton} from '@material-ui/core';
import { consumerFirebase } from '../../config';
import DocumentPDF from './DocumentPDF';
import GetData from './GetData';

const styles = StyleSheet.create({
    page: {
      flexDirection: 'row',
      backgroundColor: '#E4E4E4'
    },
    section: {
      margin: 10,
      padding: 10,
      flexGrow: 1
    },
    cardGrid: {
      paddingLeft: "5em"
  
   },
   homeIcon: {
      width: 20,
      height: 20,
      marginRight: "4px"
   },
   link: {
      display: "flex",
   },
   gridTextField: {
      marginTop: "2em"
   },
   card: {
      height: "100%",
      display: "flex",
      flexDirection:"column"
   },
   cardMedia: {
      paddingTop: "56.25%"
   },
   cardContent: {
      flexGrow: 1
   },
   tablecontainer: {
      margin: "auto"
   },
   paper: {
      marginTop: "2em",
      paddingTop: "1em",
      paddingBottom: "2em",
      alignContent: "center",
      width: "100%"
   },
   avatarRestaurant: {
      width: 100,
      height: 100,
      paddingLeft: '6%',
   },
   buttonPrint:{
       marginBottom:'3em'
   }
  });
  

class Print extends Component {

    printOrder = () => {
        const printableElements = document.getElementById('printme').innerHTML;
        const orderHtml = '<html><head><title></title></head><body>' + printableElements + '</body></html>';
        const oldPage = document.body.innerHTML;
        document.body.innerHTML = orderHtml;
        window.print();
        document.body.innerHTML = oldPage
    }

    render(){
       
        return (
            <Container style={styles.cardGrid} xs={12} md={8}>
                <Button 
                    type="button"
                    variant="contained"
                    size="large"
                    color="primary"
                    style={styles.buttonPrint}
                    onClick={() => this.printOrder()}
                >
                    Imprimir
                </Button>
                <DocumentPDF style={styles.print} printableId='printme'/>
            </Container>
              
            
          );
    }
};

export default consumerFirebase(Print);